module.exports = __webpack_public_path__ + "media/right.f5a5db89.svg";